import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';

import { HttpTestimonyService } from '../../../../core/services/http/http-testimony.service';
import { LanguageService } from '../../../../core/services/language.service';

import { InfiniteScrollDirective } from '../../../../shared/directives/infinite-scroll.directive';
import { PublicTestimoniesStoreService } from './public-testimonies.component-store';

@Component({
  selector: 'app-public-testimonies',
  templateUrl: './public-testimonies.component.html',
  styleUrls: ['./public-testimonies.component.scss'],
  providers: [PublicTestimoniesStoreService],
})
export class PublicTestimoniesComponent implements OnInit {
  constructor(
    public languageService: LanguageService,
    public componentStore: PublicTestimoniesStoreService
  ) {}

  ngOnInit() {
    this.componentStore.initList({});
  }

  scroll() {
    this.componentStore.scroll();
  }
}
